/**
 * A UUID, with a fallback for browsers that do not offer one.
 *
 * `crypto.randomUUID()` needs a secure context and Safari 15.4 or newer. Calling it unguarded
 * would throw while the search composable is being set up, taking the whole search component down
 * with it - on an older browser the portal would simply have no search. The ids are only used to
 * tie the requests of one search together, so the fallback does not need to be cryptographic.
 */
export function uuid(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;

        return v.toString(16);
    });
}
